import { isDevelopmentEnvironment } from "@/lib/env";

export let isClientCnpjChangeEnabled = false;

// Troca de CNPJ disponível somente em ambiente de Desenvolvimento (localhost/homologação).
// Comente a linha abaixo para desativar a troca de CNPJ no frontend.
isClientCnpjChangeEnabled = isDevelopmentEnvironment;
